/* Pack to Plate — GSAP choreography (hero intro, scroll reveals,
   marquee velocity, card tilt, parallax, counters). Desktop-first. */
(function () {
  'use strict';

  function init() {
    if (typeof gsap === 'undefined') {
      document.documentElement.classList.add('ptp-no-gsap');
      return;
    }
    if (typeof ScrollTrigger !== 'undefined') gsap.registerPlugin(ScrollTrigger);

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      gsap.set('[data-ptp-reveal]', { opacity: 1, y: 0 });
      return;
    }

    /* ---------- hero intro ---------- */
    var hero = document.querySelector('.ptp-hero');
    if (hero) {
      var lines = hero.querySelectorAll('.ptp-line > span');
      var tl = gsap.timeline({ defaults: { ease: 'power4.out' } });
      var heroKicker = hero.querySelector('.ptp-hero__kicker');
      if (heroKicker) tl.from(heroKicker, { y: 24, opacity: 0, duration: 0.9 }, 0.15);
      /* logo + triangle mark appears immediately — no intro tween */
      if (lines.length) tl.from(lines, { yPercent: 110, duration: 1.15, stagger: 0.12 }, 0.5);

      tl.timeScale(0.2); /* slow the whole intro 5x */
      /* badge is intentionally static — no intro tween, no rotation */
      /* no scroll parallax on the hero so it stays flush with the marquee below */
    }

    if (typeof ScrollTrigger === 'undefined') {
      gsap.set('[data-ptp-reveal]', { opacity: 1, y: 0 });
      return;
    }

    /* ---------- generic scroll reveals ---------- */
    document.querySelectorAll('[data-ptp-reveal]').forEach(function (el, i) {
      gsap.to(el, {
        opacity: 1, y: 0, duration: 1.1, ease: 'power3.out',
        delay: (parseInt(el.getAttribute('data-ptp-delay') || 0, 10)) * 0.1,
        scrollTrigger: { trigger: el, start: 'top 86%', once: true }
      });
    });

    /* ---------- marquee: base crawl + scroll-velocity boost ---------- */
    document.querySelectorAll('.ptp-marquee').forEach(function (mq) {
      var track = mq.querySelector('.ptp-marquee__track');
      if (!track) return;
      var half = track.scrollWidth / 2;
      var crawl = gsap.to(track, { x: -half, duration: 130, repeat: -1, ease: 'none' });
      ScrollTrigger.create({
        onUpdate: function (self) {
          var v = Math.min(Math.abs(self.getVelocity()) / 280, 5);
          gsap.to(crawl, { timeScale: 1 + v, duration: 0.4, overwrite: true });
        }
      });
    });

    /* ---------- meal cards: 3D tilt ---------- */
    document.querySelectorAll('.ptp-meal-card').forEach(function (card) {
      var visual = card.querySelector('.ptp-meal-card__visual');
      if (!visual) return;
      var qx = gsap.quickTo(visual, 'rotationY', { duration: 0.5, ease: 'power3' });
      var qy = gsap.quickTo(visual, 'rotationX', { duration: 0.5, ease: 'power3' });
      var qs = gsap.quickTo(visual, 'scale', { duration: 0.5, ease: 'power3' });
      card.addEventListener('pointermove', function (e) {
        var r = visual.getBoundingClientRect();
        qx(((e.clientX - r.left) / r.width - 0.5) * 14);
        qy(-((e.clientY - r.top) / r.height - 0.5) * 14);
        qs(1.03);
      });
      card.addEventListener('pointerleave', function () { qx(0); qy(0); qs(1); });
    });

    /* Story photos are deliberately static — the scroll parallax was removed
       2026-08-28. If it ever comes back, .ptp-story__media img needs its
       height: 115% restored too, or there is no slack for it to move within. */

    /* ---------- about-page photos: settle-in scale ----------
       Deliberately not the story parallax: these frames crop to an exact
       object-position set in the editor, so the image has no vertical slack
       to drift within. Scaling from inside the frame keeps the crop honest. */
    document.querySelectorAll('.ptp-about__frame').forEach(function (frame) {
      var img = frame.querySelector('img');
      if (!img) return;
      gsap.fromTo(img, { scale: 1.08 }, {
        scale: 1, duration: 1.6, ease: 'power3.out',
        scrollTrigger: { trigger: frame, start: 'top 85%', once: true }
      });
    });

    /* ---------- story body: staggered paragraph reveal ---------- */
    document.querySelectorAll('.ptp-story__body, .ptp-about__prose').forEach(function (body) {
      var paras = body.querySelectorAll('p');
      if (!paras.length) return;
      gsap.from(paras, {
        opacity: 0, y: 26, duration: 0.9, stagger: 0.14, ease: 'power3.out',
        scrollTrigger: { trigger: body, start: 'top 82%', once: true }
      });
    });

    /* ---------- stockists map: draw the coastline, fade the fill, pop the markers ---------- */
    document.querySelectorAll('.ptp-stockists__mapwrap').forEach(function (wrap) {
      var paths = wrap.querySelectorAll('.ptp-stockists__map svg path');
      var tris = wrap.querySelectorAll('.ptp-stockists__tri');
      if (!paths.length) return;
      var tl = gsap.timeline({ scrollTrigger: { trigger: wrap, start: 'top 80%', once: true } });
      paths.forEach(function (p) {
        var len = p.getTotalLength ? p.getTotalLength() : 4000;
        gsap.set(p, { strokeDasharray: len, strokeDashoffset: len, fillOpacity: 0 });
        tl.to(p, { strokeDashoffset: 0, duration: 1.6, ease: 'power2.inOut' }, 0);
        tl.to(p, { fillOpacity: 1, duration: 0.7, ease: 'power1.out' }, 1.0);
      });
      if (tris.length) {
        gsap.set(tris, { scale: 0 });
        tl.to(tris, { scale: 1, duration: 0.55, ease: 'back.out(2.2)', stagger: 0.12 }, 1.3);
      }
    });

    /* ---------- stat counters ---------- */
    document.querySelectorAll('.ptp-stat__num [data-count]').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-count'));
      var obj = { v: 0 };
      gsap.to(obj, {
        v: target, duration: 1.8, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 88%', once: true },
        onUpdate: function () { el.textContent = Math.round(obj.v); }
      });
    });

    /* ---------- ingredient credentials: draw-on trail seals ---------- */
    if (typeof ScrollTrigger !== 'undefined') {
      document.querySelectorAll('.ptp-cred').forEach(function (cred) {
        var ring = cred.querySelector('.ptp-cred__ring');
        var tick = cred.querySelector('.ptp-cred__tick');
        var seal = cred.querySelector('.ptp-cred__seal');
        if (!ring || !tick) return;
        var rLen = ring.getTotalLength ? ring.getTotalLength() : 250;
        var tLen = tick.getTotalLength ? tick.getTotalLength() : 70;
        gsap.set(ring, { strokeDasharray: rLen, strokeDashoffset: rLen });
        gsap.set(tick, { strokeDasharray: tLen, strokeDashoffset: tLen });
        gsap.timeline({ scrollTrigger: { trigger: cred, start: 'top 82%', once: true } })
          .fromTo(seal, { scale: 0.6, rotate: -16, opacity: 0 },
                        { scale: 1, rotate: 0, opacity: 1, duration: 0.5, ease: 'back.out(2)' })
          .to(ring, { strokeDashoffset: 0, duration: 0.7, ease: 'power2.inOut' }, '-=0.2')
          .to(tick, { strokeDashoffset: 0, duration: 0.4, ease: 'power2.out' }, '-=0.12');
      });
    }

    /* ---------- big display headings: word-level stagger ---------- */
    document.querySelectorAll('[data-ptp-words]').forEach(function (h) {
      var words = h.querySelectorAll('.ptp-word');
      if (!words.length) return;
      gsap.from(words, {
        yPercent: 60, opacity: 0, duration: 0.9, stagger: 0.06, ease: 'power3.out',
        scrollTrigger: { trigger: h, start: 'top 84%', once: true }
      });
    });
  }

  /* back-to-top trail marker — independent of GSAP */
  function initBackToTop() {
    var btn = document.querySelector('.ptp-totop');
    if (!btn) return;
    var shown = false;
    function onScroll() {
      var past = window.scrollY > window.innerHeight * 0.85;
      if (past !== shown) {
        shown = past;
        btn.classList.toggle('is-visible', shown);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    onScroll();
  }

  /* ---------- product gallery: arrows, keyboard, thumbnails, swappable transitions ---------- */
  function initGallery() {
    var stage = document.querySelector('.ptp-pd__stage');
    if (!stage) return;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.ptp-pd__thumb'));
    var images = thumbs.map(function (t) { return t.getAttribute('data-full'); });
    if (images.length < 2) return; /* single image: nothing to navigate */

    var index = 0;
    var busy = false;
    var hasGsap = typeof gsap !== 'undefined';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fx = new URLSearchParams(window.location.search).get('fx');
    var mode = fx || stage.getAttribute('data-transition') || 'crossfade';

    function setActive(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
    }

    function promote(incoming, current) {
      incoming.removeAttribute('style');
      incoming.classList.remove('ptp-pd__main--incoming');
      incoming.classList.add('is-current');
      incoming.id = 'ptp-pd-main';
      if (current && current.parentNode) current.parentNode.removeChild(current);
      busy = false;
    }

    function show(i, dir) {
      if (busy || i === index || !images[i]) return;
      var current = stage.querySelector('.ptp-pd__main.is-current');
      var incoming = document.createElement('img');
      incoming.className = 'ptp-pd__main ptp-pd__main--incoming';
      incoming.src = images[i];
      incoming.alt = '';
      stage.appendChild(incoming);
      index = i;
      setActive(i);

      if (!hasGsap || reduced) { promote(incoming, current); return; }
      busy = true;
      runTransition(mode, stage, incoming, current, dir, function () { promote(incoming, current); });
    }

    function go(step) {
      var n = images.length;
      show((index + step + n) % n, step > 0 ? 'next' : 'prev');
    }

    thumbs.forEach(function (t, n) {
      t.addEventListener('click', function () { show(n, n > index ? 'next' : 'prev'); });
    });
    document.querySelectorAll('[data-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () { go(btn.getAttribute('data-nav') === 'next' ? 1 : -1); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.target && /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
      if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
    });
  }

  /* one transition per named mode; calls done() when the incoming image has fully arrived */
  function runTransition(mode, stage, incoming, current, dir, done) {
    var d = dir === 'prev' ? -1 : 1;

    if (mode === 'slide') {
      gsap.set(incoming, { opacity: 1, xPercent: 100 * d });
      gsap.to(incoming, { xPercent: 0, duration: 0.6, ease: 'power3.inOut' });
      if (current) gsap.to(current, { xPercent: -100 * d, duration: 0.6, ease: 'power3.inOut' });
      gsap.delayedCall(0.62, done);

    } else if (mode === 'triangle') {
      gsap.set(incoming, { opacity: 1 });
      var ot = { p: 0 };
      gsap.to(ot, {
        p: 1, duration: 0.72, ease: 'power2.inOut',
        onUpdate: function () {
          var p = ot.p, top = 50 - 160 * p, s = 160 * p;
          incoming.style.clipPath = 'polygon(50% ' + top + '%, ' + (50 + s) + '% ' + (50 + s) + '%, ' + (50 - s) + '% ' + (50 + s) + '%)';
        },
        onComplete: function () { incoming.style.clipPath = 'none'; done(); }
      });

    } else if (mode === 'zoomblur') {
      gsap.set(incoming, { opacity: 0, scale: 1.12 });
      gsap.to(incoming, { opacity: 1, scale: 1, duration: 0.72, ease: 'power2.out' });
      var oz = { b: 16 };
      gsap.to(oz, {
        b: 0, duration: 0.72, ease: 'power2.out',
        onUpdate: function () { incoming.style.filter = 'blur(' + oz.b + 'px)'; },
        onComplete: function () { incoming.style.filter = 'none'; done(); }
      });

    } else { /* crossfade */
      gsap.set(incoming, { opacity: 0 });
      gsap.to(incoming, { opacity: 1, duration: 0.5, ease: 'power2.inOut', onComplete: done });
    }
  }

  /* ---------- back label: open the pack panel full size ---------- */
  function initLabel() {
    var opener = document.querySelector('[data-ptp-label-open]');
    var dialog = document.querySelector('[data-ptp-label-dialog]');
    if (!opener || !dialog) return;

    /* <dialog> is unsupported on older Safari; leave the image inline rather than
       wiring a button that would do nothing. */
    if (typeof dialog.showModal !== 'function') {
      opener.style.cursor = 'default';
      var deadHint = opener.querySelector('.ptp-pd-label__hint');
      if (deadHint) deadHint.remove();
      return;
    }

    opener.addEventListener('click', function () { dialog.showModal(); });

    var closer = dialog.querySelector('[data-ptp-label-close]');
    if (closer) closer.addEventListener('click', function () { dialog.close(); });

    /* click the backdrop (anywhere outside the image) to dismiss */
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', function () { opener.focus(); });
  }

  /* ---------- product page: thumbs, quantity, variant price, AJAX add-to-cart ---------- */
  function initProduct() {
    initGallery();
    initLabel();

    var form = document.getElementById('ptp-pd-form');

    if (form) {
      var qty = form.querySelector('.ptp-pd__qty-input');
      form.querySelectorAll('.ptp-pd__qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qty) return;
          var n = (parseInt(qty.value, 10) || 1) + (btn.getAttribute('data-qty') === 'up' ? 1 : -1);
          qty.value = Math.max(1, n);
        });
      });
    }

    var variant = document.getElementById('ptp-pd-variant');
    var priceEl = document.getElementById('ptp-pd-price');
    if (variant && priceEl) {
      variant.addEventListener('change', function () {
        var opt = variant.options[variant.selectedIndex];
        var p = opt && opt.getAttribute('data-price');
        if (p) priceEl.textContent = p;
      });
    }

    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.ptp-pd__add');
        if (btn) btn.classList.add('is-loading');
        fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { return updateCartCount(); })
          .then(function () { showToast(); })
          .catch(function () { form.submit(); })
          .then(function () { if (btn) btn.classList.remove('is-loading'); });
      });
    }
  }

  function updateCartCount() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var wrap = document.getElementById('cart-icon-bubble');
        if (!wrap) return;
        var bubble = wrap.querySelector('.cart-count-bubble');
        if (bubble) {
          var span = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span');
          if (span) { span.textContent = cart.item_count; } else { bubble.textContent = cart.item_count; }
        } else {
          var b = document.createElement('div');
          b.className = 'cart-count-bubble';
          b.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
          wrap.appendChild(b);
        }
      })
      .catch(function () {});
  }

  function showToast() {
    var toast = document.querySelector('.ptp-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ptp-toast';
      toast.setAttribute('role', 'status');
      toast.innerHTML = '<span class="ptp-toast__tri" aria-hidden="true"></span><span>Packed!</span>';
      document.body.appendChild(toast);
    }
    void toast.offsetWidth; /* reflow so the first transition runs */
    toast.classList.add('is-visible');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 2400);
  }

  /* ---------- edge-pan strips (trail strip + blog): pan by hovering near the left/right edge ---------- */
  function initEdgePan() {
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!fine) return; /* touch / coarse pointer: native swipe handles it */
    document.querySelectorAll('.ptp-edge-pan').forEach(function (vp) {
      var vel = 0, running = false;
      var DEAD = 0.16;  /* central no-scroll zone (fraction either side of centre) */
      var MAX = 20;     /* px per frame at the very edge */
      function tick() {
        if (vel !== 0) vp.scrollLeft += vel;
        if (running) requestAnimationFrame(tick);
      }
      vp.addEventListener('pointermove', function (e) {
        var r = vp.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width; /* 0 = left edge, 1 = right edge */
        if (x > 0.5 + DEAD) vel = ((x - (0.5 + DEAD)) / (0.5 - DEAD)) * MAX;
        else if (x < 0.5 - DEAD) vel = -(((0.5 - DEAD) - x) / (0.5 - DEAD)) * MAX;
        else vel = 0;
        if (!running) { running = true; requestAnimationFrame(tick); }
      });
      vp.addEventListener('pointerleave', function () { vel = 0; running = false; });
    });
  }

  function boot() { init(); initBackToTop(); initProduct(); initEdgePan(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
